import React, { type ReactNode } from 'react';

import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';
import type { DropdownItemProps } from '@atlaskit/dropdown-menu/types';
import type { AnyEntryPoint } from '@atlassian/entry-point-types';

import { ModalTrigger, type ModalTriggerProps as ModalTriggerProps } from './modal-trigger';

export type ModalDropdownItemTriggerProps<TEntryPoint> = Omit<
	ModalTriggerProps<TEntryPoint>,
	'children' | 'title'
> & {
	modalTitle?: ReactNode;
} & Omit<DropdownItemProps, 'ref'>; // Prevent ref prop collision between ButtonProps and render prop

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const ModalDropdownItemTrigger = <TEntryPoint extends AnyEntryPoint>({
	children,
	entryPoint,
	entryPointParams,
	entryPointProps,
	Fallback,
	modalTitle,
	modalProps,
	forwardedRef,
	preloadOnFocus,
	loadingText,
	...dropdownProps
}: ModalDropdownItemTriggerProps<TEntryPoint>): React.JSX.Element => {
	return (
		<ModalTrigger
			forwardedRef={forwardedRef}
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			entryPointProps={entryPointProps}
			Fallback={Fallback}
			title={modalTitle}
			modalProps={modalProps}
			preloadOnFocus={preloadOnFocus}
			loadingText={loadingText}
		>
			{({ ref }) => (
				<DropdownItem ref={ref} {...dropdownProps}>
					{children}
				</DropdownItem>
			)}
		</ModalTrigger>
	);
};
